import type { ReactNode } from 'react';
import { createContext } from 'react';

export interface ModalContextType {
  onClose: () => void;
}

const ModalContext = createContext<ModalContextType | null>(null);

interface ModalProviderProps {
  children: ReactNode;
  onClose: () => void;
}

export const ModalProvider = ({ children, onClose }: ModalProviderProps) => {
  return <ModalContext.Provider value={{ onClose }}>{children}</ModalContext.Provider>;
};

export { ModalContext };
